import React, { useEffect, useState } from "react";
import { IconButton, Box, Typography, Paper, Chip, Stack, Tooltip } from '@mui/material';

import moment from "moment";
import "dayjs/locale/es";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { grey } from "@mui/material/colors";
import dayjs from 'dayjs';
import {
    ChevronLeft,
    ChevronRight,
    Today,
    LocalShipping,
} from "@mui/icons-material";

export default function Barra(props) {
    const palette = {
        bg: "#1F618D",         // azul base
        bgHover: "#1A5276",    // azul oscuro (hover/fondos internos)
        bgActive: "#2471A3",   // azul claro (estados activos)
        accent: "#fff",
        textPrimary: "#EBF5FB", // azul blanquecino (texto principal)
        textSecondary: "#AED6F1", // azul pastel (texto secundario)
        divider: "#1A5276",    // azul oscuro (divisores)
        chipBg: "#1A5276",     // azul oscuro (fondo chips)
        chipText: "#D6EAF8",   // azul muy claro (texto chips)
    };

    const { fecha, handleChangeMenos, handleChangeMas, handleChangeHoy, setFecha, navegar, handleVolver } = props;
    const [onFocus, setOnFocus] = useState();
    const isToday = false;

    return (
        <div>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                <Paper
                    elevation={5}
                    sx={{
                        background: palette.bg,
                        borderRadius: "12px",
                        px: { xs: 1.5, sm: 3 },
                        mt: 2,
                        py:2
                    }}
                >
                    <Stack
                        direction="row"
                        alignItems="center"
                        sx={{
                            width: "100%",
                        }}
                    >
                        <Box sx={{ flex: 1, display: "flex", alignItems: "center", gap: 1 }}>
                            {
                                handleVolver && (
                                    <IconButton
                                        onClick={handleVolver} 
                                        sx={{ color: "#ffffff" }}
                                    >
                                        <ArrowBackIcon sx={{ color: grey[50] }} />
                                    </IconButton>
                                )
                            }
                            {
                                navegar && (
                                    <>
                                        <Stack direction="row" alignItems="center" spacing={1} justifyContent="center" >
                                            <Box sx={{ display: { xs: "none", md: "flex" }, flexDirection: "row", alignItems: "flex-start", justifyContent:"center" }}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                                                        <DatePicker
                                                            value={fecha ? dayjs(fecha) : null}
                                                            slotProps={{
                                                                textField: {
                                                                    onFocus: () => setOnFocus(true),
                                                                    onBlur: () => setOnFocus(false),
                                                                    size: "small",
                                                                    sx: {
                                                                        width: 160,
                                                                        "& .MuiOutlinedInput-root": {
                                                                            backgroundColor: palette.bgHover,
                                                                            borderRadius: "10px",
                                                                            color: palette.textPrimary,
                                                                            fontSize: "0.85rem",
                                                                            transition: "all 0.2s ease",
                                                                            "& fieldset": {
                                                                                borderColor: palette.divider,
                                                                            },
                                                                            "&:hover fieldset": {
                                                                                borderColor: palette.accent,
                                                                            },
                                                                            "&.Mui-focused fieldset": {
                                                                                borderColor: palette.accent,
                                                                                borderWidth: "1px",
                                                                            },
                                                                        },
                                                                        "& .MuiInputAdornment-root .MuiIconButton-root": {
                                                                            color: palette.accent,
                                                                            transition: "color 0.2s ease",
                                                                            "&:hover": {
                                                                                color: palette.textPrimary,
                                                                            },
                                                                        },
                                                                        "& .MuiFormHelperText-root": {
                                                                            color: palette.accent,
                                                                            fontSize: "0.6rem",
                                                                            mt: 0.5,
                                                                            opacity: 0.7,
                                                                        },
                                                                    },
                                                                    onKeyDown: (e) => {
                                                                        if (e.key === "Enter") {
                                                                            const fecha = moment(e.target.value, "DD/MM/YYYY").format("YYYY-MM-DD")
                                                                            setFecha(fecha)
                                                                        }
                                                                    }
                                                                },
                                                            }}
                                                            size="small"
                                                            onAccept={(value) => {
                                                                if (value?.isValid()) {
                                                                    const fechaFormateada = value.format("YYYY-MM-DD");
                                                                    setFecha(fechaFormateada)
                                                                }
                                                            }}
                                                        />
                                                </LocalizationProvider>
                                            </Box>
                                            <Typography sx={{ color: "#fff", fontSize: 12, fontWeight: 10, visibility: onFocus ? "visible" : "hidden" }} variant="button">
                                                enter para buscar
                                            </Typography>
                                        </Stack>
                                    </>

                                )
                            }
                        </Box>
                        <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1.5}
                            sx={{
                                position: "absolute",
                                left: "50%",
                                transform: "translateX(-50%)"
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: 36,
                                    height: 36,
                                    borderRadius: "10px",
                                    backgroundColor: palette.bgHover,
                                    // p: 1
                                }}
                            >
                                <LocalShipping
                                    sx={{ color: palette.accent, fontSize: 24 }}
                                />
                            </Box>
                            <Box>
                                <Typography
                                    variant="subtitle1"
                                    sx={{
                                        color: palette.textPrimary,
                                        fontWeight: 600,
                                        fontSize: { xs: "1rem", sm: "1rem" },
                                        lineHeight: 1.3,
                                        letterSpacing: "-0.01em",
                                    }}
                                >
                                    Listar Repartos
                                </Typography>
                                <Typography
                                    variant="caption"
                                    sx={{
                                        color: palette.accent,
                                        fontSize: "0.85rem",
                                        fontWeight: 500,
                                        display: { xs: "none", sm: "block" },
                                    }}
                                >
                                    {fecha}
                                    {/* Finalizado el: {fecha} */}
                                </Typography>
                            </Box>
                        </Stack>

                        {
                            navegar && (
                                <>
                                    <Stack
                                        direction="row"
                                        alignItems="center"
                                        spacing={0.5}
                                        sx={{
                                            backgroundColor: palette.bgHover,
                                            borderRadius: "10px",
                                            px: 1,
                                            py: 0.5,
                                        }}
                                    >
                                        <Tooltip title="Dia anterior" arrow>
                                            <IconButton
                                                size="small"
                                                onClick={handleChangeMenos}
                                                sx={{
                                                    color: palette.accent,
                                                    transition: "all 0.2s ease",
                                                    "&:hover": {
                                                        color: palette.textPrimary,
                                                        backgroundColor: palette.bgActive,
                                                    },
                                                }}
                                            >
                                                <ChevronLeft fontSize="small" />
                                            </IconButton>
                                        </Tooltip>

                                        <Tooltip title="Ir a hoy" arrow>
                                            <Chip
                                                label={ "Hoy"}
                                                size="small"
                                                onClick={handleChangeHoy}
                                                icon={
                                                    <Today
                                                        sx={{
                                                            fontSize: 16,
                                                            color: isToday
                                                                ? `${palette.textPrimary} !important`
                                                                : `${palette.accent} !important`,
                                                        }}
                                                    />
                                                }
                                                sx={{
                                                    backgroundColor: isToday ? palette.bgActive : "transparent",
                                                    color: isToday ? palette.textPrimary : palette.chipText,
                                                    fontWeight: 500,
                                                    fontSize: "0.8rem",
                                                    minWidth: 110,
                                                    border: `1px solid ${palette.divider}`,
                                                    transition: "all 0.2s ease",
                                                    cursor: "pointer",
                                                    "&:hover": {
                                                        backgroundColor: palette.bgActive,
                                                        color: palette.textPrimary,
                                                    },
                                                }}
                                            />
                                        </Tooltip>

                                        <Tooltip title="Dia siguiente" arrow>
                                            <IconButton
                                                size="small"
                                                onClick={handleChangeMas}
                                                sx={{
                                                    color: palette.accent,
                                                    transition: "all 0.2s ease",
                                                    "&:hover": {
                                                        color: palette.textPrimary,
                                                        backgroundColor: palette.bgActive,
                                                    },
                                                }}
                                            >
                                                <ChevronRight fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    </Stack>
                                </>
                            )
                        }
                    </Stack>
                </Paper>
            </LocalizationProvider>
        </div>
    )
}